import { render, staticRenderFns } from "./ImageIconCloseCSS.vue?vue&type=template&id=7920c607&scoped=true&"
import script from "./ImageIconCloseCSS.vue?vue&type=script&lang=js&"
export * from "./ImageIconCloseCSS.vue?vue&type=script&lang=js&"
import style0 from "./ImageIconCloseCSS.vue?vue&type=style&index=0&id=7920c607&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7920c607",
  null
  
)

export default component.exports